// Constants for UI conventions, consistency across the site

/* eslint import/prefer-default-export: 0 */
const dataCaptureTimeout = 2000;
const momentaryMessageDuration = 3000;

export { dataCaptureTimeout, momentaryMessageDuration };
